import * as React from 'react';
import { Button, styled, Typography } from '@mui/material';

import Column from 'src/frontend-common/components/Column';
import Disconnect from 'src/frontend-common/components/Icons/Disconnect';
import { Link } from 'react-router-dom';

const Spacer = styled(Column)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  lineHeight: 1.2,
  color: theme.palette.primary.main,
  marginBottom: 20,
  textAlign: 'center',
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  lineHeight: 1.1,
  color: theme.palette.text.primary,
  textAlign: 'center',
}));

const CustomButton = styled(Button)(({ theme }) => ({
  height: 56,
  width: '100%',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(3),
  },
}));

const CustomLink = styled(Link)(({}) => ({
  color: '#FFFFFF',
  width: '100%',
  textDecoration: 'none',
}));

const Page404: React.FC<{ error?: string }> = ({ error }) => {
  return (
    <div
      style={{
        textAlign: 'center',
        paddingTop: 130,
        margin: '0 auto',
        width: '35%',
      }}
    >
      <div style={{ marginBottom: 24 }}>
        <Disconnect />
      </div>

      <Spacer centered>
        <Title style={{ fontSize: 40, fontWeight: 600, color: 'black' }}>Something went wrong</Title>
        <Subtitle>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: '#616161',
              marginBottom: 24,
            }}
          >
            {error || 'You either tried some shady route or you came here by mistake.Whichever it is, try using the navigation'}
          </Typography>
        </Subtitle>
      </Spacer>

      <Column centered>
        {!error ? (
          <CustomButton
            variant="contained"
            style={{ backgroundColor: 'black' }}
            disableElevation={true}
            // onClick={resendCallback.callback}
          >
            <CustomLink to="/"> Back to Dashboard</CustomLink>
          </CustomButton>
        ) : (
          <CustomButton
            variant="contained"
            style={{ backgroundColor: 'black' }}
            disableElevation={true}
            onClick={() => {
              window.location.href = '/';
            }}
          >
            Back to Dashboard
          </CustomButton>
        )}
      </Column>
    </div>
  );
};

export default Page404;
